import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { NoResults } from './no-results';

export const NoFilterResults = () => {
  const { t } = useTranslation();

  return (
    <div className="h-[calc(100%-100px)] flex items-center justify-center">
      <div className="flex flex-col gap-y-4 items-center justify-center">
        <NoResults />
        <div className="text-center text-xl font-medium xtext-neutral-b0">
          {t('content-hub.no-results-found')}
        </div>
        <div className="text-center text-sm text-neutral-b0">
          {t('content-hub.no-results-found-description')}
        </div>
      </div>
    </div>
  );
};
